const SITE_URL = "https://shoppingdobem.com.br";

const DEFAULT_OG_IMAGE =
  "https://storage.googleapis.com/gpt-engineer-file-uploads/pOOf9Nrh78WhUebLRzOJgp5GbQl2/social-images/social-1779720587727-Design_sem_nome_-_2026-05-25T114758.465.webp";

export interface SeoHeadOptions {
  title: string;
  description: string;
  path?: string;
  canonical?: string;
  noindex?: boolean;
  ogImage?: string | null;
  ogType?: string;
}

/**
 * Monta os metadados para o head() das rotas — mesma fonte de verdade que o
 * usePageSeo do cliente, mas renderizada no HTML do servidor (SEO/compartilhamento).
 */
export function seoHead({
  title,
  description,
  path,
  canonical,
  noindex,
  ogImage,
  ogType = "website",
}: SeoHeadOptions) {
  const url = canonical || (path ? `${SITE_URL}${path}` : undefined);
  const image = ogImage === undefined ? DEFAULT_OG_IMAGE : ogImage;

  const meta: Array<Record<string, string>> = [
    { title },
    { name: "description", content: description },
    { property: "og:type", content: ogType },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow" },
  ];
  if (image) meta.push({ property: "og:image", content: image }, { name: "twitter:image", content: image });
  if (url) meta.push({ property: "og:url", content: url });

  return {
    meta,
    ...(url ? { links: [{ rel: "canonical", href: url }] } : {}),
  };
}
